import { render, staticRenderFns } from "./index.vue?vue&type=template&id=6f4c4ac7"
import script from "./index.vue?vue&type=script&lang=js"
export * from "./index.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* custom blocks */
import block0 from "./index.vue?vue&type=custom&index=0&blockType=router"
if (typeof block0 === 'function') block0(component)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {PatternsSearchEmpty: require('/home/node/app/components/patterns/search-empty/search-empty.vue').default,PatternsRetailerMessage: require('/home/node/app/components/patterns/retailer-message/retailer-message.vue').default,TemplatesCatalogListing: require('/home/node/app/components/templates/catalog-listing/catalog-listing.vue').default})
